import clsx from "clsx";
import { useGameStore } from "../../store/gameStore";

export function ConnectionPill() {
  const conn = useGameStore((s) => s.conn);
  const tone = conn === "online" ? "text-emerald" : conn === "reconnecting" ? "text-brass" : "text-ink-faint";
  const label = conn === "online" ? "Online" : conn === "reconnecting" ? "Riconnessione…" : "Offline";
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-line px-2.5 py-1 text-[0.7rem] font-medium">
      <span className={clsx("h-1.5 w-1.5 rounded-full", conn === "online" ? "bg-emerald" : conn === "reconnecting" ? "bg-brass animate-pulse-soft" : "bg-ink-faint")} />
      <span className={tone}>{label}</span>
    </span>
  );
}
